export default __webpack_public_path__ + "static/media/qoin-logo.de74da8e.svg";